import type { ReactNode } from 'react';

export const symbol_switch: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M220-80q-24 0-42-18t-18-42v-680q0-24 18-42t42-18h520q24 0 42 18t18 42v680q0 24-18 42t-42 18H220Zm0-60h520v-680H220v680Zm135-145h249q12.75 0 21.38-8.63Q634-302.25 634-315v-329q0-12.75-8.62-21.38Q616.75-674 604-674H355q-12.75 0-21.37 8.62Q325-656.75 325-644v329q0 12.75 8.63 21.37Q342.25-285 355-285Zm30-60v-187h189v187H385Zm95.47-383q8.46 0 14-5.53 5.53-5.54 5.53-14 0-8.47-5.53-14.47-5.54-6-14-6-8.47 0-14.47 6t-6 14.47q0 8.46 6 14 6 5.53 14.47 5.53Zm0 535q8.46 0 14-5.53 5.53-5.54 5.53-14 0-8.47-5.53-14.47-5.54-6-14-6-8.47 0-14.47 6t-6 14.47q0 8.46 6 14 6 5.53 14.47 5.53ZM480-480Z"
		/>
	</svg>
);
